// extracted by mini-css-extract-plugin
module.exports = {"orderNotPossible":"Material_orderNotPossible__D3Bt6","errorLabel":"Material_errorLabel__UidzD"};